import type { KeyNameType } from '@tunasong/music-lib'
import type { Scale } from '@tunasong/schemas'
import type { FC } from 'react'
import { KeyButton } from './key-button.js'
import { KeySelect } from './key-select.js'

export interface ScaleSelectProps {
  className?: string
  value?: Partial<Scale> | null
  title?: string
  fullWidth?: boolean
  variant?: KeyNameType
  allowNone?: boolean
  /**
   * The key control (key selector #2764) in one of two presentations (one key picker everywhere, #3004; spec
   * docs/ux/2026-10-31-key-picker-everywhere.md §2): `grid` shows it inline, where the picker is the content (a
   * properties panel, a key popover); `button` puts it behind a one-line "Key" chip, where the key is a setting above
   * other content (a tool page).
   */
  layout?: 'grid' | 'button'
  /** Grid layout: `view` opens "More scales" in place, for the phone drawer */
  moreAs?: 'menu' | 'view'
  /** Grid layout: the phone view's back button, named for where it returns */
  moreBackLabel?: string
  onChange(scale: Scale | null): void
}

export const ScaleSelect: FC<ScaleSelectProps> = props => {
  const {
    value = null,
    allowNone = true,
    onChange,
    variant = 'common',
    layout = 'button',
    title,
    moreAs,
    moreBackLabel,
    className,
  } = props

  if (layout === 'button') {
    return <KeyButton className={className} value={value} variant={variant} allowNone={allowNone} onChange={onChange} />
  }

  return (
    <KeySelect
      className={className}
      value={value}
      title={title}
      variant={variant}
      allowNone={allowNone}
      moreAs={moreAs}
      moreBackLabel={moreBackLabel}
      onChange={onChange}
    />
  )
}
